import type { File, Folder, Item } from '@/shared/graphql/router/graphql'

export function isFile(item: Item): item is File {
  return item.__typename === 'File'
}

export function isFolder(item: Item): item is Folder {
  return item.__typename === 'Folder'
}
